import { render, staticRenderFns } from "./ot-coming-soon-wrapper.vue?vue&type=template&id=da38f2e4&scoped=true&"
import script from "./ot-coming-soon-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-coming-soon-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-coming-soon-wrapper.vue?vue&type=style&index=0&id=da38f2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da38f2e4",
  null
  
)

export default component.exports